'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { SearchBox, useSearchBox } from 'react-instantsearch';
import { debounce } from 'lodash';
import avo from 'analytics/avo';
import { ALGOLIA_INDEX_NAME, DEFAULT_SEARCH_PLACEHOLDER, SEARCH_STATE_UPDATE_DEBOUNCE_MS, SEARCH_INPUT_MAX_LENGTH, ALL_FACETS_FILTER } from 'commons/constants';
import useIsBrowser from 'hooks/useIsBrowser';
import isClient from 'commons/isClient';
import IconSearch from 'components/icons/IconSearch';
import IconClose from 'components/icons/iconClose';
import useScreen from 'hooks/useScreen';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from '../../../commons/helpers';
import getQuickLinkMatch from '../QuickLinkDialog/getQuickLinkMatch';
import useDebouncedAlgoliaQueryHook from './useDebouncedAlgoliaQueryHook';
const JBSearchBoxNext = t0 => {
  const $ = _c(90);
  let advanced;
  let autoFocus;
  let forPage;
  let handleSearchBarFocus;
  let index;
  let initialQueryValue;
  let isActive;
  let otherProps;
  let setSearchStateQuery;
  let t1;
  let t2;
  let toggleMobileSearchBar;
  let variant;
  if ($[0] !== t0) {
    const {
      advanced: t3,
      autoFocus: t4,
      defaultRefinement,
      forPage: t5,
      index: t6,
      inMobileNav: t7,
      isActive: t8,
      placeholder: t9,
      setInactive,
      variant: t10,
      initialQueryValue: t11,
      setSearchStateQuery: t12,
      toggleMobileSearchBar: t13,
      handleSearchBarFocus: t14,
      ...t15
    } = t0;
    advanced = t3;
    autoFocus = t4;
    forPage = t5;
    index = t6;
    t1 = t7;
    isActive = t8;
    t2 = t9;
    variant = t10;
    initialQueryValue = t11;
    setSearchStateQuery = t12;
    toggleMobileSearchBar = t13;
    handleSearchBarFocus = t14;
    otherProps = t15;
    $[0] = t0;
    $[1] = advanced;
    $[2] = autoFocus;
    $[3] = forPage;
    $[4] = handleSearchBarFocus;
    $[5] = index;
    $[6] = initialQueryValue;
    $[7] = isActive;
    $[8] = otherProps;
    $[9] = setSearchStateQuery;
    $[10] = t1;
    $[11] = t2;
    $[12] = toggleMobileSearchBar;
    $[13] = variant;
  } else {
    advanced = $[1];
    autoFocus = $[2];
    forPage = $[3];
    handleSearchBarFocus = $[4];
    index = $[5];
    initialQueryValue = $[6];
    isActive = $[7];
    otherProps = $[8];
    setSearchStateQuery = $[9];
    t1 = $[10];
    t2 = $[11];
    toggleMobileSearchBar = $[12];
    variant = $[13];
  }
  const inMobileNav = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? DEFAULT_SEARCH_PLACEHOLDER : t2;
  const history = useHistory();
  const currentPage = useUserCurrentPageType();
  const [searchQuery, updateSearchQuery] = useState(initialQueryValue || "");
  const {
    query: searchBoxQuery
  } = useSearchBox();
  const {
    isMobile
  } = useScreen();
  const isBrowser = useIsBrowser();
  const advancedInputRef = useRef(null);
  const {
    queryHook,
    cancel: cancelDebouncedQuery,
    getTypedQuery
  } = useDebouncedAlgoliaQueryHook();
  let t3;
  let t4;
  if ($[14] !== autoFocus) {
    t3 = () => {
      if (autoFocus) {
        advancedInputRef.current?.focus();
      }
    };
    t4 = [autoFocus];
    $[14] = autoFocus;
    $[15] = t3;
    $[16] = t4;
  } else {
    t3 = $[15];
    t4 = $[16];
  }
  useEffect(t3, t4);
  let t5;
  if ($[17] !== isBrowser || $[18] !== setSearchStateQuery) {
    t5 = debounce(updatedValue => {
      if (isBrowser && setSearchStateQuery) {
        setSearchStateQuery(updatedValue);
      }
    }, SEARCH_STATE_UPDATE_DEBOUNCE_MS);
    $[17] = isBrowser;
    $[18] = setSearchStateQuery;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  const debouncedSearchStateQueryUpdate = t5;
  let t6;
  if ($[20] !== debouncedSearchStateQueryUpdate) {
    t6 = event => {
      const {
        value
      } = event.target;
      updateSearchQuery(value);
      debouncedSearchStateQueryUpdate(value);
    };
    $[20] = debouncedSearchStateQueryUpdate;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  const handleQueryChange = t6;
  let t7;
  if ($[22] !== currentPage || $[23] !== history || $[24] !== otherProps) {
    t7 = (quickLinkMatch, queryValue) => {
      avo.productsSearched({
        query: queryValue,
        location: currentPage,
        searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
      });
      history.push(quickLinkMatch.url);
      otherProps?.toggleSearchOpen();
    };
    $[22] = currentPage;
    $[23] = history;
    $[24] = otherProps;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const goToQuickLinkPage = t7;
  let t8;
  if ($[26] !== advanced || $[27] !== cancelDebouncedQuery || $[28] !== currentPage || $[29] !== getTypedQuery || $[30] !== goToQuickLinkPage || $[31] !== history || $[32] !== index || $[33] !== isBrowser || $[34] !== otherProps || $[35] !== searchBoxQuery || $[36] !== searchQuery) {
    t8 = () => {
      if (isBrowser) {
        const queryToUse = advanced ? searchQuery : getTypedQuery() || searchBoxQuery;
        cancelDebouncedQuery();
        const quickLinkMatch_0 = getQuickLinkMatch(queryToUse);
        if (quickLinkMatch_0) {
          goToQuickLinkPage(quickLinkMatch_0, queryToUse);
          return;
        }
        avo.productsSearched({
          query: queryToUse,
          location: currentPage,
          searchTarget: avo.SearchTarget.FULL_RESULTS
        });
        const newUrl = getAdvancedSearchUrlForQueryAndIndex(queryToUse, index || ALGOLIA_INDEX_NAME.PRODUCTS, ALL_FACETS_FILTER);
        history.push(newUrl, {
          instantQuery: queryToUse
        });
        otherProps?.toggleSearchOpen();
      }
    };
    $[26] = advanced;
    $[27] = cancelDebouncedQuery;
    $[28] = currentPage;
    $[29] = getTypedQuery;
    $[30] = goToQuickLinkPage;
    $[31] = history;
    $[32] = index;
    $[33] = isBrowser;
    $[34] = otherProps;
    $[35] = searchBoxQuery;
    $[36] = searchQuery;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  const goToAdvancedSearch = t8;
  let t9;
  if ($[38] !== currentPage || $[39] !== forPage || $[40] !== goToQuickLinkPage || $[41] !== history || $[42] !== index || $[43] !== isMobile || $[44] !== otherProps) {
    t9 = e => {
      if (isMobile) {
        updateSearchQuery(e.currentTarget.value);
        if (otherProps.setSearchEventParams) {
          otherProps.setSearchEventParams({
            searchQuery: e.currentTarget.value,
            currentPage
          });
        }
        if ((e.key === "Enter" || e.keyCode === 13) && isClient()) {
          const quickLinkMatch_1 = getQuickLinkMatch(e.currentTarget.value);
          if (quickLinkMatch_1) {
            goToQuickLinkPage(quickLinkMatch_1, e.currentTarget.value);
          }
        }
        return;
      }
      if (forPage !== "associate" && (e.key === "Enter" || e.keyCode === 13) && e.target.value !== "" && isClient()) {
        const quickLinkMatch_2 = getQuickLinkMatch(e.target.value);
        if (quickLinkMatch_2) {
          goToQuickLinkPage(quickLinkMatch_2, e.target.value);
          return;
        }
        avo.productsSearched({
          query: e.target.value,
          location: currentPage,
          searchTarget: avo.SearchTarget.FULL_RESULTS
        });
        const newUrl_0 = getAdvancedSearchUrlForQueryAndIndex(e.target.value, index || ALGOLIA_INDEX_NAME.PRODUCTS, ALL_FACETS_FILTER);
        history.push(newUrl_0, {
          instantQuery: e.target.value
        });
        otherProps?.toggleSearchOpen();
      }
    };
    $[38] = currentPage;
    $[39] = forPage;
    $[40] = goToQuickLinkPage;
    $[41] = history;
    $[42] = index;
    $[43] = isMobile;
    $[44] = otherProps;
    $[45] = t9;
  } else {
    t9 = $[45];
  }
  const handleKeyDown = t9;
  const t10 = variant === "ConsumerInstantSearch";
  let t11;
  if ($[46] !== t10) {
    t11 = classNames("[&_i]:w-[18px] [&_i]:h-[18px] [&_i]:text-[18px] [&_i]:block [&_i]:absolute [&_i]:top-1/2 [&_i]:mt-[-9px] [&_i]:right-10 [&_i]:cursor-pointer [&_i]:[border-right:1px_solid_#dfe0e1] bg-gray-light8", {
      "py-3": t10
    });
    $[46] = t10;
    $[47] = t11;
  } else {
    t11 = $[47];
  }
  const t12 = variant !== "ConsumerInstantSearch";
  const t13 = variant === "ConsumerInstantSearch";
  const t14 = variant === "ConsumerInstantSearch" && isActive;
  const t15 = variant === "InstantSearchMobile";
  let t16;
  if ($[48] !== inMobileNav || $[49] !== t12 || $[50] !== t13 || $[51] !== t14 || $[52] !== t15) {
    t16 = classNames("mx-5 my-0 flex flex-row items-stretch relative box-border min-[1440px]:mx-[3.333vw] min-[1440px]:my-0", {
      "px-0 py-[5px]": t12,
      "!ml-3": inMobileNav,
      "px-3 bg-white rounded-[5px] border border-gray-light6 [&_.ais-SearchBox-input]:lg:!pl-0 [&_.ais-SearchBox-input]:lg:!text-left [&_.ais-SearchBox-input]:lg:!indent-[12px] [&_.ais-SearchBox-input::placeholder]:lg:!text-left [&_.ais-SearchBox-input.hasValue]:lg:!indent-[24px]": t13,
      "[&_button.ais-SearchBox-reset]:!block": t14,
      "[&_.ais-SearchBox-input]:indent-[12px]": t15
    });
    $[48] = inMobileNav;
    $[49] = t12;
    $[50] = t13;
    $[51] = t14;
    $[52] = t15;
    $[53] = t16;
  } else {
    t16 = $[53];
  }
  const t17 = variant === "InstantSearchMobile";
  let t18;
  if ($[54] !== t17) {
    t18 = classNames("self-center min-w-[16px]", {
      hidden: t17
    });
    $[54] = t17;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== t18) {
    t19 = <IconSearch className={t18} width={18} height={18} />;
    $[56] = t18;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  let t20;
  if ($[58] !== advanced || $[59] !== handleKeyDown || $[60] !== handleQueryChange || $[61] !== placeholder || $[62] !== searchQuery) {
    t20 = advanced && <div className="inline-flex w-full pl-2"><div className="flex w-full"><input ref={advancedInputRef} className="text-left pl-[30px] [appearance:unset] bg-none [background:none] border-[1px] border-solid border-transparent text-[#333] block [font-size:1rem] font-bold h-10 leading-[1.45rem] tracking-[-.0125rem] w-full" type="search" placeholder={placeholder} autoComplete="off" autoCapitalize="off" spellCheck={false} maxLength={SEARCH_INPUT_MAX_LENGTH} value={searchQuery} onChange={handleQueryChange} onKeyDown={handleKeyDown} /></div></div>;
    $[58] = advanced;
    $[59] = handleKeyDown;
    $[60] = handleQueryChange;
    $[61] = placeholder;
    $[62] = searchQuery;
    $[63] = t20;
  } else {
    t20 = $[63];
  }
  let t21;
  if ($[64] !== advanced || $[65] !== autoFocus || $[66] !== handleKeyDown || $[67] !== handleSearchBarFocus || $[68] !== placeholder || $[69] !== queryHook) {
    t21 = !advanced && <div className="inline-flex w-full" onClick={handleSearchBarFocus} role="button" tabIndex={0}><SearchBox placeholder={placeholder} autoFocus={autoFocus} onKeyDown={handleKeyDown} queryHook={queryHook} /></div>;
    $[64] = advanced;
    $[65] = autoFocus;
    $[66] = handleKeyDown;
    $[67] = handleSearchBarFocus;
    $[68] = placeholder;
    $[69] = queryHook;
    $[70] = t21;
  } else {
    t21 = $[70];
  }
  let t22;
  if ($[71] !== goToAdvancedSearch || $[72] !== isBrowser || $[73] !== toggleMobileSearchBar || $[74] !== variant) {
    t22 = isBrowser && variant === "InstantSearchMobile" && <div className="flex gap-2 items-center"><IconSearch className="self-center min-w-[16px] cursor-pointer" width={18} height={18} onClick={goToAdvancedSearch} /><div className="text-gray">|</div><IconClose className="self-center min-w-[16px] cursor-pointer" width={14} height={14} color="#424242" onClick={toggleMobileSearchBar} /></div>;
    $[71] = goToAdvancedSearch;
    $[72] = isBrowser;
    $[73] = toggleMobileSearchBar;
    $[74] = variant;
    $[75] = t22;
  } else {
    t22 = $[75];
  }
  let t23;
  if ($[76] !== t16 || $[77] !== t19 || $[78] !== t20 || $[79] !== t21 || $[80] !== t22) {
    t23 = <div className={t16}>{t19}{t20}{t21}{t22}</div>;
    $[76] = t16;
    $[77] = t19;
    $[78] = t20;
    $[79] = t21;
    $[80] = t22;
    $[81] = t23;
  } else {
    t23 = $[81];
  }
  let t24;
  if ($[82] !== isActive || $[83] !== isMobile || $[84] !== variant) {
    t24 = isMobile && <div className={classNames("h-0 w-0 top-[65px] z-[-1] left-0 fixed bg-white [transition:opacity_.3s_ease-out] opacity-0 lg:absolute lg:bg-transparent", {
      active: isActive,
      hidden: variant === "InstantSearchMobile",
      "lg:opacity-100 lg:h-screen lg:w-screen lg:top-[-100px] lg:absolute lg:[transition:opacity_.3s_ease-out]": isActive
    })} />;
    $[82] = isActive;
    $[83] = isMobile;
    $[84] = variant;
    $[85] = t24;
  } else {
    t24 = $[85];
  }
  let t25;
  if ($[86] !== t11 || $[87] !== t23 || $[88] !== t24) {
    t25 = <div className={t11}>{t23}{t24}</div>;
    $[86] = t11;
    $[87] = t23;
    $[88] = t24;
    $[89] = t25;
  } else {
    t25 = $[89];
  }
  return t25;
};
export default JBSearchBoxNext;